import { ORDER_STATUS } from '../../../constants/config';

const couponCodeColumn = {
  field: 'coupon_code',
  label: 'reports_settings.coupon_code',
};

export const couponColumns = [
  couponCodeColumn,
  { field: 'coupon_name', label: 'reports_settings.coupon_name' },
  {
    field: 'total_orders',
    label: 'reports_settings.total_orders',
    numeric: true,
  },
  {
    field: 'total_discount',
    label: 'reports_settings.total_discount',
    numeric: true,
    money: true,
  },
];

export const couponOrderColumns = [
  { field: 'order_number', label: 'reports_settings.order_number' },
  { field: 'placed_at', label: 'reports_settings.placed_at' },
  { field: 'brand_name', label: 'reports_settings.brand_name' },
  { field: 'location_name', label: 'reports_settings.location_name' },
  {
    field: 'provider',
    label: 'reports_settings.providers',
    provider: true,
  },
  {
    field: 'order_status',
    label: 'reports_settings.order_status',
    status: true,
  },
  // totalField names the coupon amount this column is totalled by in the
  // footer of the expanded order list.
  {
    field: 'sub_total',
    label: 'reports_settings.order_subtotal',
    numeric: true,
    money: true,
    totalField: 'subtotal_sales',
  },
  {
    field: 'discount',
    label: 'reports_settings.coupon_discount',
    numeric: true,
    money: true,
    totalField: 'total_discount',
  },
];

// The CSV lists the order rows in their own section, away from the coupon rows,
// so they repeat the coupon code to stay traceable to the summary above.
export const couponCsvOrderColumns = [couponCodeColumn, ...couponOrderColumns];

export const formatMoney = (value) => {
  if (!Number.isFinite(Number(value))) {
    return '';
  }
  return `$${Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const getCouponCellValue = (row, column, { t, providers }) => {
  if (column.status) {
    const status = ORDER_STATUS[row[column.field]];
    return status ? t(status.name) : row[column.field];
  }
  if (column.provider) {
    return providers[row[column.field]]?.label || row[column.field];
  }
  if (column.money) {
    return formatMoney(row[column.field]);
  }
  return row[column.field];
};
